module.exports = {
  localeName: 'en-IE',
  momentFormat: 'DD/MM/YYYY'
};
